import { render, staticRenderFns } from "./MNDetailFilter.vue?vue&type=template&id=324ed73a&"
import script from "./MNDetailFilter.vue?vue&type=script&lang=ts&"
export * from "./MNDetailFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports